module.exports = __webpack_public_path__ + "img/Art05-19970043-001.58b58cde.jpg";